import { calculateMidColor } from './colors';

export const FLAKE_MIN_COLOUR = '#FF2B2B';
export const FLAKE_MAX_COLOUR = '#00E613';

type Points = [number, number, number, number, number];

const getSnowflakeColor = (points: Points, alpha: number = 1) => {
  const maxSum = 30;
  const minSum = 5;
  const sum: number = points.reduce((a, b) => +a + (+b - 1), 0);
  const colour = 1 - (sum - minSum) / (maxSum - minSum);

  let flakeColorValue = 0;

  flakeColorValue = Math.max(colour, 0);
  flakeColorValue = Math.min(colour, 1);

  return calculateMidColor(
    FLAKE_MAX_COLOUR,
    FLAKE_MIN_COLOUR,
    flakeColorValue,
    alpha
  );
};

export const getSnowflakeFillColor = (points: Points) =>
  getSnowflakeColor(points, 0.7);

export const getSnowflakeStrokeColor = (points: Points) =>
  getSnowflakeColor(points);
